import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';
import { HeightType } from '../../models/height-type.enum';
import { AppConfig } from '../../../core/services/app-config.service';
import { MainNotificationService } from '../../../core/services/main-notification.service';
import { MatToolbar } from '@angular/material/toolbar';
import { NgStyle } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-secondary-toolbar',
  styleUrls: ['./secondary-toolbar.component.scss'],
  templateUrl: './secondary-toolbar.component.html',
  imports: [
    MatToolbar,
    NgStyle,
  ],
})
export class SecondaryToolbarComponent implements OnInit {
  @Input() public maxWidth = '960px';
  @Input() public heightType: HeightType = HeightType.FIXED;
  @Input() public noPadding = false;

  public padding: string;
  public heightTypeEnum = HeightType;
  public toolbarStyle: { top: string };

  constructor(
    private elem: ElementRef,
    public handsetService: HandsetService,
    private renderer: Renderer2,
    public appConfig: AppConfig,
    private mainNotificationService: MainNotificationService,
  ) {
    this.handsetService.handsetChanges.subscribe((state) => (this.padding = state ? '8px' : '24px'));
  }

  public ngOnInit(): void {
    this.renderer.setStyle(
      this.elem.nativeElement,
      'margin-bottom',
      this.handsetService.isHandset ? (this.noPadding ? '0' : '16px') : '24px',
    );

    this.mainNotificationService.mainNotificationHeightAsObservable().subscribe((height: number) => {
      this.toolbarStyle = height
        ? {
            top: height + 56 + 'px',
          }
        : null;
    });
  }
}
